import { render, staticRenderFns } from "./CatalogBrand.vue?vue&type=template&id=7fcf3d45&"
import script from "./CatalogBrand.vue?vue&type=script&lang=js&"
export * from "./CatalogBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports